module.exports = __webpack_public_path__ + "img/appstore.0ecb82a5.png";